<template>
  
    <div class="h-full w-full lg:mt-40">
  
             <div class="h-2/3 w-full">
  
               <transition name="fade" appear class="bg-pink-400 h-1/2 w-full">
                  <div class="h-full w-full flex">
  
                      <div class="w-full h-screen mb-4">
  
                          <locations-map :memberships="modalMemberships" :showOnlyOneMembership="showOnlyOneMembership" :oneMembership="oneMembership"
                           :dayDate="dayDate" :setHighlighted="setHighlighted"
                          :refreshedMap="refreshedMap"/>
                      </div>
                  </div>
              </transition>
          </div>
  
           <div v-if="highLightedSlotsList.length > 0" class="mySessionsDivider p-1 mt-4">
  
              <div v-for="(highLightedSlot,index) in highLightedSlotsList" :key="index"
              class="">
  
                  <div class="myCardDiv">
                      <studio-membership-card :email="email" :key="highLightedSlot.id" :showDescription="showDescription"
                    :myReload="myReload" :isCard="true" :disableButton="disableButton" :disablePage="disablePage"
                      :membership="highLightedSlot" :dayDate="dayDate"/>
                  </div>   
      
              </div> 
          </div>  
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  
  import LocationsMap from './StudiosMembershipsLocationsMap.vue';
  
  
  import StudioMembershipCard from './StudioMembershipCard';
  
  export default {
  
      mounted(){
  
      },
  
      props:{
  
          refreshedMap: 0,
  
          tokenId: 0,
          
          showMembershipPage: {
  
              type: Function
          },
  
          showOnlyOneMembership: false,
  
          oneMembership: {
  
              type: Object
          },
  
          myReload: {
  
              type: Function
          },
  
           displayModal: {
  
              type: Function
          },
  
          showDescription:{
  
              type: Function
          },
  
          email: '',
  
          isCard: false,
  
  
          dayDate: '',
  
          changeShowModal:{
  
              type: Function
          },
  
  
          modalMemberships: {
              type: Array 
          },
  
          showModal: false,
      },
  
      components: {
  
      LocationsMap,
      StudioMembershipCard
      },
  
      methods:{
  
  
          setHighlighted(membership, index){
  
              this.index;
              this.highLightedSlotsList = this.modalMemberships.filter(item => item.business.location.id == membership.business.location.id);
    
          },
  
  
      },
  
      data: function(){
  
          return{
  
              displayingImage: '',
              disablePage: false,
              highLightedSlotsList: [],
              disableButton: false,
  
              index: 0,
          }
      },
  }
  </script>
  
  <style>

  
  @media screen and (max-width: 768px) {
  
      .modal-overlay {
  
          position: absolute;
  
          top: 25%;
  
      }
  }
  
  @media screen and (min-width: 768px) {
  
      .modal-overlay {
  
          position: absolute;
    
          top: 25%;
          left: 25%;
      }
  
  }
  </style>